export default __webpack_public_path__ + "static/media/upload_cancel.a322adde.svg";